// src/pages/TourPackages.jsx
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next'; // <-- Added
import { motion } from 'framer-motion';

// === IMAGES ===
import tourPackagesBg from '../assets/Aamy/38.jpg';
import pkg1 from '../assets/pick2/Ella/pexels-freestockpro-321569.jpg';
import pkg2 from '../assets/pick2/Ella/pexels-iakub-arifulin-205356454-11675420.jpg';
import pkg3 from '../assets/pick2/kandy/pexels-freestockpro-322437.jpg';
import pkg4 from '../assets/pick2/kandy/SL_Kandy_asv2020-01_img04_Queens_Hotel.jpg';
import pkg5 from '../assets/pick2/sigiriya/pexels-iakub-arifulin-205356454-11994203.jpg';
import pkg6 from '../assets/pick2/Galle/istockphoto-472387838-612x612.jpg';
import pkg7 from '../assets/pick2/colombo/istockphoto-1181382649-612x612.jpg';
import pkg8 from '../assets/pick2/yala/LK710A2062-02-E.webp';
import pkg9 from '../assets/pick2/Mirissa/download.jpeg';
import pkg10 from '../assets/pick2/udawalawe/istockphoto-2155402343-612x612.jpg';
import pkg11 from '../assets/Aamy/39.jpg';
import pkg12 from '../assets/pick2/yala/LK710A2062-06-E.webp';
import pkg13 from '../assets/pick2/kandy/istockphoto-1285881901-612x612.jpg';
import pkg14 from '../assets/pick2/kandy/Trekking-the-roots-of-tea-header.jpg';
import pkg15 from '../assets/Aamy/36.jpg';
import pkg16 from '../assets/pick2/Ella/pexels-costa-18498686.jpg';
import pkg17 from '../assets/pick2/Ella/pexels-iakub-arifulin-205356454-11675420.jpg';
import pkg18 from '../assets/pick2/polonnaruwa/istockphoto-1184393376-612x612.jpg';
import pkg19 from '../assets/pick2/polonnaruwa/istockphoto-481368600-612x612.jpg';
import pkg20 from '../assets/pick2/Anuradapura/istockphoto-1178654295-612x612.jpg';
import pkg21 from '../assets/pick2/Anuradapura/istockphoto-1255135539-612x612.jpg';
import pkg22 from '../assets/pick2/Galle/istockphoto-1191225810-612x612.jpg';
import pkg23 from '../assets/pick2/colombo/pexels-ssasanka-2239999.jpg';
import pkg24 from '../assets/pick2/sigiriya/istockphoto-1402612615-612x612.jpg';
import pkg25 from '../assets/pick2/sigiriya/istockphoto-1441928899-612x612.jpg';

// === MOTION VARIANTS ===
const sectionVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } },
};

const modalVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: { opacity: 1, scale: 1, transition: { duration: 0.4 } },
    exit: { opacity: 0, scale: 0.8, transition: { duration: 0.3 } },
};

const TourPackages = () => {
    const { t } = useTranslation('tourpackages'); // <-- Namespace

    const [selectedPackage, setSelectedPackage] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = (pkg) => {
        setSelectedPackage(pkg);
        setIsModalOpen(true);
        document.body.style.overflow = 'hidden';
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedPackage(null);
        document.body.style.overflow = 'unset';
    };

    const sendWhatsAppMessage = (pkg) => {
        const phone = "94768539635";
        const message = t('whatsappMessage', { title: pkg.title, duration: pkg.duration });
        const whatsappURL = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
        window.open(whatsappURL, '_blank');
    };

    // All package data now uses translation keys
    const packages = [
        { id: 1, image: pkg1, title: t('packages.1.title'), duration: t('packages.1.duration'), category: t('packages.1.category'), description: t('packages.1.description'), itinerary: t('packages.1.itinerary', { returnObjects: true }) },
        { id: 2, image: pkg2, title: t('packages.2.title'), duration: t('packages.2.duration'), category: t('packages.2.category'), description: t('packages.2.description'), itinerary: t('packages.2.itinerary', { returnObjects: true }) },
        { id: 3, image: pkg3, title: t('packages.3.title'), duration: t('packages.3.duration'), category: t('packages.3.category'), description: t('packages.3.description'), itinerary: t('packages.3.itinerary', { returnObjects: true }) },
        { id: 4, image: pkg4, title: t('packages.4.title'), duration: t('packages.4.duration'), category: t('packages.4.category'), description: t('packages.4.description'), itinerary: t('packages.4.itinerary', { returnObjects: true }) },
        { id: 5, image: pkg5, title: t('packages.5.title'), duration: t('packages.5.duration'), category: t('packages.5.category'), description: t('packages.5.description'), itinerary: t('packages.5.itinerary', { returnObjects: true }) },
        { id: 6, image: pkg6, title: t('packages.6.title'), duration: t('packages.6.duration'), category: t('packages.6.category'), description: t('packages.6.description'), itinerary: t('packages.6.itinerary', { returnObjects: true }) },
        { id: 7, image: pkg7, title: t('packages.7.title'), duration: t('packages.7.duration'), category: t('packages.7.category'), description: t('packages.7.description'), itinerary: t('packages.7.itinerary', { returnObjects: true }) },
        { id: 8, image: pkg8, title: t('packages.8.title'), duration: t('packages.8.duration'), category: t('packages.8.category'), description: t('packages.8.description'), itinerary: t('packages.8.itinerary', { returnObjects: true }) },
        { id: 9, image: pkg9, title: t('packages.9.title'), duration: t('packages.9.duration'), category: t('packages.9.category'), description: t('packages.9.description'), itinerary: t('packages.9.itinerary', { returnObjects: true }) },
        { id: 10, image: pkg10, title: t('packages.10.title'), duration: t('packages.10.duration'), category: t('packages.10.category'), description: t('packages.10.description'), itinerary: t('packages.10.itinerary', { returnObjects: true }) },
        { id: 11, image: pkg11, title: t('packages.11.title'), duration: t('packages.11.duration'), category: t('packages.11.category'), description: t('packages.11.description'), itinerary: t('packages.11.itinerary', { returnObjects: true }) },
        { id: 12, image: pkg12, title: t('packages.12.title'), duration: t('packages.12.duration'), category: t('packages.12.category'), description: t('packages.12.description'), itinerary: t('packages.12.itinerary', { returnObjects: true }) },
        { id: 13, image: pkg13, title: t('packages.13.title'), duration: t('packages.13.duration'), category: t('packages.13.category'), description: t('packages.13.description'), itinerary: t('packages.13.itinerary', { returnObjects: true }) },
        { id: 14, image: pkg14, title: t('packages.14.title'), duration: t('packages.14.duration'), category: t('packages.14.category'), description: t('packages.14.description'), itinerary: t('packages.14.itinerary', { returnObjects: true }) },
        { id: 15, image: pkg15, title: t('packages.15.title'), duration: t('packages.15.duration'), category: t('packages.15.category'), description: t('packages.15.description'), itinerary: t('packages.15.itinerary', { returnObjects: true }) },
        { id: 16, image: pkg16, title: t('packages.16.title'), duration: t('packages.16.duration'), category: t('packages.16.category'), description: t('packages.16.description'), itinerary: t('packages.16.itinerary', { returnObjects: true }) },
        { id: 17, image: pkg17, title: t('packages.17.title'), duration: t('packages.17.duration'), category: t('packages.17.category'), description: t('packages.17.description'), itinerary: t('packages.17.itinerary', { returnObjects: true }) },
        { id: 18, image: pkg18, title: t('packages.18.title'), duration: t('packages.18.duration'), category: t('packages.18.category'), description: t('packages.18.description'), itinerary: t('packages.18.itinerary', { returnObjects: true }) },
        { id: 19, image: pkg19, title: t('packages.19.title'), duration: t('packages.19.duration'), category: t('packages.19.category'), description: t('packages.19.description'), itinerary: t('packages.19.itinerary', { returnObjects: true }) },
        { id: 20, image: pkg20, title: t('packages.20.title'), duration: t('packages.20.duration'), category: t('packages.20.category'), description: t('packages.20.description'), itinerary: t('packages.20.itinerary', { returnObjects: true }) },
        { id: 21, image: pkg21, title: t('packages.21.title'), duration: t('packages.21.duration'), category: t('packages.21.category'), description: t('packages.21.description'), itinerary: t('packages.21.itinerary', { returnObjects: true }) },
        { id: 22, image: pkg22, title: t('packages.22.title'), duration: t('packages.22.duration'), category: t('packages.22.category'), description: t('packages.22.description'), itinerary: t('packages.22.itinerary', { returnObjects: true }) },
        { id: 23, image: pkg23, title: t('packages.23.title'), duration: t('packages.23.duration'), category: t('packages.23.category'), description: t('packages.23.description'), itinerary: t('packages.23.itinerary', { returnObjects: true }) },
        { id: 24, image: pkg24, title: t('packages.24.title'), duration: t('packages.24.duration'), category: t('packages.24.category'), description: t('packages.24.description'), itinerary: t('packages.24.itinerary', { returnObjects: true }) },
        { id: 25, image: pkg25, title: t('packages.25.title'), duration: t('packages.25.duration'), category: t('packages.25.category'), description: t('packages.25.description'), itinerary: t('packages.25.itinerary', { returnObjects: true }) },
    ];

    return (
        <div className="bg-[#0a0a0a] min-h-screen text-white">
            {/* HERO SECTION */}
            <motion.section
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.3 }}
                variants={sectionVariants}
                className="relative flex h-[60vh] w-full items-center justify-center font-redHatDisplay md:h-[70vh] lg:h-[80vh]"
            >
                <img src={tourPackagesBg} alt={t('heroAlt')} className="absolute inset-0 h-full w-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/70" />

                <div className="container relative z-10 px-4 text-center">
                    <motion.h1
                        variants={sectionVariants}
                        className="text-[2.8rem] font-bold leading-tight md:text-[3.5rem] lg:text-[5rem] font-konkhmer"
                        style={{
                            background: 'linear-gradient(to right, #166880, #D5A44F)',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                            backgroundClip: 'text',
                        }}
                    >
                        {t('heroTitle')}
                    </motion.h1>
                    <motion.p
                        variants={sectionVariants}
                        className="mx-auto mt-6 max-w-3xl text-lg font-medium text-white/90 md:text-xl lg:text-2xl"
                        dangerouslySetInnerHTML={{ __html: t('heroSubtitle') }}
                    />

                    <div className="absolute left-6 top-10 hidden md:block">
                        <svg width="250" height="200" viewBox="0 0 289 245" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M289 1H1V244.5" stroke="white" strokeOpacity="0.2" />
                        </svg>
                    </div>
                    <div className="absolute -bottom-8 right-6 hidden md:block">
                        <svg width="250" height="200" viewBox="0 0 289 244" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0 243.5H288V0" stroke="white" strokeOpacity="0.2" />
                        </svg>
                    </div>
                </div>
            </motion.section>

            {/* PACKAGES GRID */}
            <section className="container mx-auto px-4 py-16 lg:py-24">
                <div className="text-center mb-12">
                    <h2 className="text-4xl font-bold md:text-5xl lg:text-6xl font-konkhmer">
                        <span style={{
                            background: 'linear-gradient(to right, #D5A44F, #166880)',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                            backgroundClip: 'text',
                        }}>
                            {t('chooseAdventure')}
                        </span>
                    </h2>
                    <p className="mx-auto mt-6 max-w-3xl text-lg text-white/80 md:text-xl">
                        {t('packagesSubtitle')}
                    </p>
                </div>

                <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                    {packages.map((pkg) => (
                        <div
                            key={pkg.id}
                            onClick={() => openModal(pkg)}
                            className="group relative overflow-hidden rounded-2xl border border-gray-800 bg-[#111] transition-all duration-500 hover:border-[#D5A44F] hover:shadow-2xl hover:shadow-[#D5A44F]/20 cursor-pointer"
                        >
                            <div className="relative h-56 overflow-hidden md:h-64">
                                <img src={pkg.image} alt={pkg.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                            </div>

                            <div className="p-5 md:p-6">
                                <h3 className="text-sm font-bold text-white line-clamp-2 md:text-lg font-redHatDisplay">
                                    {pkg.title}
                                </h3>
                                <p className="mt-2 text-sm font-semibold text-[#D5A44F] md:text-base">
                                    {pkg.duration} • {pkg.category}
                                </p>
                                <p className="mt-3 text-sm text-white/70 line-clamp-2 md:text-base">
                                    {pkg.description}
                                </p>

                                <button className="mt-5 w-full rounded-full bg-gradient-to-r from-[#166880] to-[#D5A44F] py-3 text-sm font-bold text-white transition-all hover:scale-105 hover:shadow-lg">
                                    {t('viewDetails')}
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            {/* MODAL */}
            {isModalOpen && selectedPackage && (
                <motion.div
                    initial="hidden"
                    animate="visible"
                    exit="exit"
                    variants={modalVariants}
                    className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/90 backdrop-blur-sm"
                    onClick={closeModal}
                >
                    <motion.div
                        className="relative max-w-4xl w-full max-h-[92vh] overflow-y-auto rounded-2xl border border-[#D5A44F]/30 bg-[#111] p-6 shadow-2xl md:p-8"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button onClick={closeModal} className="absolute right-4 top-4 text-white hover:text-[#D5A44F] transition">
                            <svg className="h-8 w-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>

                        <div className="text-center mt-16">
                            <h2 className="text-2xl font-bold text-white md:text-3xl lg:text-3xl font-konkhmer ">
                                {selectedPackage.title}
                            </h2>
                            <p className="mt-2 text-lg font-semibold text-[#D5A44F]">
                                {selectedPackage.duration} • {selectedPackage.category}
                            </p>
                        </div>

                        <div className="mt-8">
                            <h3 className="mb-4 text-xl font-bold text-[#166880]">{t('itineraryTitle')}</h3>
                            <div
                                className="prose prose-invert max-w-none text-white/90"
                                dangerouslySetInnerHTML={{ __html: selectedPackage.itinerary }}
                            />
                        </div>

                        <div className="mt-10 text-center">
                            <button
                                onClick={() => sendWhatsAppMessage(selectedPackage)}
                                className="inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-[#25D366] to-[#128C7E] px-6 py-3 text-base font-bold text-white transition-all hover:scale-105 hover:shadow-xl"
                            >
                                <svg className="h-6 w-6" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.297-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.208-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.263c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.884 3.488" />
                                </svg>
                                {t('bookViaWhatsApp')}
                            </button>
                        </div>
                    </motion.div>
                </motion.div>
            )}
        </div>
    );
};

export default TourPackages;